import React, { useEffect, useState } from "react";
import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import { useFormik } from "formik";
import axios from "axios";
import Supplier from "../../../Assets/Images/OMS_New/payment (1).svg";
function SupplierPayemntsDetails({ orderId, omsData }) {
  const [isSupplierPaymentDetails, setIsSupplierPaymentDetails] =
    useState(true);

  const initialValues = {
    firstPayment: null,
    hold_amount: null,
    deduction_amount: null,
    final_amount: null,
    total_paid_amount: null,
  };
  const formik = useFormik({
    initialValues: initialValues,
  });
  console.log(omsData, "OMS SUpplier Data");
  useEffect(() => {
    formik.setValues({
      ...formik.values,
      firstPayment: omsData?.only_bnps?.supplier_total_transfer_amt
        ? omsData?.only_bnps?.supplier_total_transfer_amt
        : 0,
      hold_amount:
        Number(omsData?.only_bnps?.total_cp) * 0.99 -
          Number(omsData?.only_bnps?.supplier_total_transfer_amt) >
        0
          ? Number(omsData?.only_bnps?.total_cp) -
            Number(omsData?.only_bnps?.supplier_total_transfer_amt)
          : 0,
      deduction_amount: 0,
      final_amount:
        Number(omsData?.only_bnps?.total_cp) * 0.99 -
          Number(omsData?.only_bnps?.supplier_total_transfer_amt) >
        0
          ? Number(omsData?.only_bnps?.supplier_total_transfer_amt)
          : 0,
    });
  }, [omsData, formik.setValues]);

  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-1">
          {" "}
          <img src={Supplier} alt="" />
          <div className="ms-1">Supplier Payments Details</div>
        </div>
        <div>
          {isSupplierPaymentDetails ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() =>
                  setIsSupplierPaymentDetails(!isSupplierPaymentDetails)
                }
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() =>
                  setIsSupplierPaymentDetails(!isSupplierPaymentDetails)
                }
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>

      <div>
        {isSupplierPaymentDetails ? (
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div>
                  <label
                    for="firstPayment"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    First Part Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="firstPayment"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="firstPayment"
                    placeholder="Enter First Payment"
                    value={
                      formik.values.firstPayment
                        ? formik.values.firstPayment
                        : 0
                    }
                    onChange={formik.handleChange}
                    step="any"
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="hold_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Hold Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="hold_amountt"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="hold_amountt"
                    placeholder="Enter Hold Amount"
                    value={
                      formik.values.hold_amount ? formik.values.hold_amount : 0
                    }
                    onChange={formik.handleChange}
                    step="any"
                    disabled
                  />
                </div>
                {/* <div>
                  <label
                    for="deduction_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Deduction Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="deduction_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="deduction_amount"
                    placeholder="Enter Deduction Amount"
                    value={
                      formik.values.deduction_amount
                        ? formik.values.deduction_amount
                        : 0
                    }
                    onChange={formik.handleChange}
                    step="any"
                  />
                </div> */}
                <div>
                  <label
                    for="final_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Final Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="final_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="final_amount"
                    placeholder="Enter Final Amount"
                    value={
                      formik.values.final_amount
                        ? formik.values.final_amount
                        : 0
                    }
                    onChange={formik.handleChange}
                    step="any"
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="final_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Total Paid Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="total_paid_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="total_paid_amount"
                    placeholder="Enter Total Paid Amount"
                    value={
                      formik.values.total_paid_amount
                        ? formik.values.total_paid_amount
                        : 0
                    }
                    onChange={formik.handleChange}
                    step="any"
                    disabled
                  />
                </div>
              </div>
            </form>
          </div>
        ) : (
          ""
        )}
      </div>
      {/* ------------------------- View Documents Model -------------------------------------------------------- */}
      {/* <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={() => handleModalClose()}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal> */}
    </div>
  );
}

export default SupplierPayemntsDetails;
